/**
 * Project : plantepourtous
 * Date : 9/9/19
 * Author : Vincent Loy <vincent.loy1@gmail.com>
 * Copyright (c) Loy Vincent
 */

'use strict';
import $ from 'jquery';
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle';
import Swup from 'swup';
import justifiedGallery from 'justifiedGallery';
import simpleLightbox from 'simplelightbox';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import slick from 'slick-carousel';

// import '../styles/main.scss';

let pageCarousel;


/**
 * Load basic functions here
 */
let mount = function () {

};

/**
 * Functions reloaded each time that swup replace content
 */
let mountSwup = function () {
    pageCarousel = $('.page-gallery');

    if (pageCarousel.length) {
        pageCarousel.slick({
            autoplay: true,
            arrows: false,
            dots: false,
            fade: true,
            speed: 2000,
            autoplaySpeed: 5000,
            infinite: true,
        });
    }

    let aaGallery = $('.aa-post-gallery');
    if (aaGallery.length) {
        aaGallery.justifiedGallery({
            lastRow: 'justify',
            margins: 5,
        });

        let galleryLinks = aaGallery.find('a');

        galleryLinks.simpleLightbox();
    }

    let dataNumTargets = document.querySelectorAll('[data-number-target]');
    if (dataNumTargets) {
        Array.prototype.forEach.call(dataNumTargets, (el) => {
            const target = el.getAttribute('data-number-target');
            let current = 0;

            let interval = window.setInterval(() => {
                if (current < target) {
                    current += 1;
                    el.innerHTML = current;
                } else {
                    clearInterval(interval);
                }
            }, 5);
        });
    }
};

let swupContentReplaced = function () {
    mountSwup();
    window.scrollTo(0, 0);
};

let swupWillReplaceContent = () => {
    pageCarousel.slick('unslick');
};

let swupTransitionStart = () => {

};

let init = function () {
    const swup = new Swup({
        containers: [
            '#swup',
            '#aa-navigation-wrapper',
        ],
        cache: false,
        plugins: [
            new SwupBodyClassPlugin(),
        ]
    });

    swup.on('contentReplaced', swupContentReplaced);
    swup.on('willReplaceContent', swupWillReplaceContent);
    swup.on('transitionStart', swupTransitionStart);

    mount();
    mountSwup();
};

$(document).ready(function () {
    init();
});
